import { FC, useCallback, useEffect } from 'react';
import { useForm } from 'react-final-form';

import { ProgressButton } from '@beeline/design-system-react/extracted-styles';

import { deletePlace } from 'src/store/admin/services';
import { useAppDispatch } from 'src/store/useAppDispatch';

export interface ActionsProps {
  existing?: boolean;
}

export const Actions: FC<ActionsProps> = ({ existing }) => {
  const dispatch = useAppDispatch();

  const { submit } = useForm();

  const saveBookingObject = useCallback(async () => {
    const result = await submit();
    if (!result) throw new Error('Form is invalid');
  }, [submit]);

  const deleteBookingObject = useCallback(async () => {
    await dispatch(deletePlace());
  }, [dispatch]);

  const handleKeydown = useCallback(
    (event: KeyboardEvent) => {
      if (event.repeat) return;

      if (event.key === 'Enter') {
        submit();
      }
    },
    [submit],
  );

  useEffect(() => {
    window.addEventListener('keydown', handleKeydown);

    return () => {
      window.removeEventListener('keydown', handleKeydown);
    };
  }, [handleKeydown]);

  return (
    <>
      {existing && (
        <ProgressButton
          variant='outlined'
          onClick={deleteBookingObject}
          data-testid='deleteBookingObject'
          statusDelayTime={0}
        >
          Удалить
        </ProgressButton>
      )}
      <ProgressButton
        variant='contained'
        onClick={saveBookingObject}
        data-testid='saveBookingObject'
        type='submit'
      >
        {existing ? 'Сохранить' : 'Создать'}
      </ProgressButton>
    </>
  );
};
